import React, { FC, useState } from "react";

import { Button, Icon, Typography } from "ui-library/atoms";
import { ContentBox } from "ui-library/layouts";
import { DataTable } from "ui-library/modules";

import i18n from "core/i18n";
import { DocumentLink } from "containers/DocumentLink";
import { useHasRole } from "core/hooks";
import { Roles } from "enums";
import { vehicleChangeApi } from "serverApi";

import FileUploadModal from "./FileUploadModal";
import { Map } from "immutable";

export interface RequestDocumentSignPhysicalProps {
    idChange: string;
    uploadedFile: Map<any, any>;
}

export const RequestDocumentSignPhysical: FC<RequestDocumentSignPhysicalProps> = ({ idChange, uploadedFile }) => {
    const { t } = i18n.useTranslation();
    const isAuthenticated = useHasRole(Roles.AUTHENTICATED);

    const downloadUrl = () => vehicleChangeApi.getDocumentToSignDownloadUrl(idChange);

    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

    const physicalSignatureColumns = [
        {
            field: "label",
            headerName: `${t("change.mandatoryAttachment")}`,
            flex: 3.5,
            sortable: false,
            renderCell: () => {
                return isAuthenticated ? (
                    <DocumentLink fileName={t("change.signature.downloadDocumentToSign")} fileUrl={downloadUrl()} />
                ) : (
                    t("change.signature.signedRequest")
                );
            },
        },
        {
            field: "id",
            headerName: `${t("common.insertDocument")}`,
            flex: 1,
            sortable: false,
            renderCell: () => (
                <Button onClick={() => setIsUploadModalOpen(true)} rounded variant="text" color="blue" startIcon={"file-plus"} />
            ),
        },
        {
            field: "status",
            headerName: `${t("vehicle.change.subject.documents.attachmentStatus")}`,
            flex: 0.5,
            sortable: false,
            renderCell: () => uploadedFile && <Icon size={16} color={"green"} icon={"circle-check"} />,
        },
    ];

    return (
        <>
            <ContentBox fullWidth textAlign={"center"} mt={4}>
                <Typography variant="h3">{t("change.signature.requestSignatures")}</Typography>
            </ContentBox>
            <ContentBox fullWidth textAlign={"center"}>
                <Typography>{t("change.signature.infoText")}</Typography>
            </ContentBox>

            <ContentBox fullWidth>
                <DataTable
                    disableColumnReorder
                    getRowId={(row) => row.id}
                    pageSize={10}
                    rows={[{ label: "sign", id: "123", status: "" }]}
                    columns={physicalSignatureColumns}
                    hideFooter
                />
            </ContentBox>

            {/* Modals */}
            <FileUploadModal open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)} />
        </>
    );
};
